import { Snackbar } from '@mui/material';
import PropTypes from 'prop-types';

function SnackBarComp({ msg, handleClose }) {
  return (
    <Snackbar
      open={open}
      classes={{ root: 'snackbar' }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={6000}
      onClose={handleClose}
      message={msg}
      // action={action}
    />
  );
}

export default SnackBarComp;

SnackBarComp.propTypes = {
  msg: PropTypes.string,
  handleClose: PropTypes.func
};
